import { Component, Inject, OnInit } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';


@Component({
  selector: 'app-traceability-detail',
  templateUrl: './traceability-detail.component.html',
  styleUrls: ['./traceability-detail.component.scss']
})
export class TraceabilityDetailComponent implements OnInit {

  json: any;
  title: string;

  constructor(public dialogRef: MatDialogRef<TraceabilityDetailComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              public dialog: MatDialog) {
  }

  ngOnInit(): void {
    console.log("Entra en traceability-detail");
    this.json = this.data.json;
    this.title = this.data.title;
  }

}
